import { TCreateModifierAction, CreateModifierActionTypes } from './createModifierActions';
import { ICreateModifierState } from './createModifierContext';

export const createModifierReducer = (
	state: ICreateModifierState,
	action: TCreateModifierAction,
): ICreateModifierState => {
	switch (action.type) {
		case CreateModifierActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateModifierActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
				fetchedRestaurants: [],
			};
		case CreateModifierActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateModifierActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateModifierActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case CreateModifierActionTypes.CHANGE_NAME_OF_MODIFIER:
			return {
				...state,
				nameOfModifier: action.payload.nameOfModifier,
			};
		case CreateModifierActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateModifierActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case CreateModifierActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case CreateModifierActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateModifierActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateModifierActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateModifierActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateModifierActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateModifierActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateModifierActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				nameOfModifier: '',
				description: '',
				externalId: '',
				hasSchedulePriority: false,
				activationSchedule: '',
				deactivationSchedule: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
